import { GAEvent, PageType, Platform, TrackingLogin } from '../tracking';
import { gaClientId, isPWA } from '../utils';

interface SignUpTrackingProps {
  customerId: string;
  customerName: string;
  customerChannel: string;
  localTimestamp: string;
  siteMarket: string;
  siteLanguage: string;
  siteEnvironment: string;
  pageType: PageType;
  userId: string;
}

export const SignUpTracking = ({
  customerId,
  customerName,
  customerChannel,
  localTimestamp,
  siteMarket,
  siteLanguage,
  siteEnvironment,
  pageType,
  userId
}: SignUpTrackingProps): TrackingLogin => ({
  dataLayer: {
    event: GAEvent.SignUp,
    event_name: GAEvent.SignUp,
    user_id: userId,
    customer_id: customerId,
    customer_name: customerName,
    customer_channel: customerChannel,
    local_timestamp: localTimestamp,
    site_environment: siteEnvironment,
    site_language: siteLanguage,
    site_market: siteMarket,
    platform: isPWA() ? Platform.Webapp : Platform.Web,
    client_id: gaClientId,
    page_type: pageType
  }
});
